import React from 'react';
import styled, { css } from '../../styled';
import * as Button from '../button/Button';
import Text from '../text';
import { media } from '../../themes/breakpoint';
const Mask = styled.div `
  display: none;
  background-color: black;
  z-index: ${({ theme }) => theme.zIndex.Mask};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0;
  ${media.mobile `
    opacity: 0.3;
  `};
  ${({ isShow }) => isShow &&
    css `
      display: block;
    `}
`;
const Container = styled.div `
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.Drawer};
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 2px 1px ${({ theme }) => theme.colors.INK_A100},
    0 0 1rem 0 ${({ theme }) => theme.colors.SHADOW_LIGHT};
  overflow: hidden;
  transition: width 0.3s ease-out, min-width 0.3s ease-out;

  ${({ isShow }) => !isShow &&
    css `
      width: 0;
      min-width: 0;
    `}

  ${({ isShow }) => `
      & > * {
        width: 21.875rem;
        min-width: 21.5625rem;
      }
      ${isShow &&
    css `
          width: 21.875rem;
          min-width: 21.5625rem;
        `}
    `}

  ${({ isShow }) => media.mobile `
    & > * {
      width: calc(100vw - 2rem);
      min-width: calc(100vw - 2rem);
    }
    ${isShow &&
    css `
        width: calc(100vw - 2rem);
        min-width: calc(100vw - 2rem);
      `}
  `}
`;
const Header = styled.header `
  box-sizing: border-box;
  padding: 1.5rem;
  background-color: ${({ theme }) => theme.colors.SNOW_200};
`;
const Body = styled.div `
  flex: 1;
  box-sizing: border-box;
  padding: 1.5rem;
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  overflow-y: auto;
  overflow-x: hidden;
`;
const Footer = styled.footer `
  box-sizing: border-box;
  padding: 1rem 1.5rem;
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.SNOW_200};
  > * {
    width: 48%;
  }
`;
const Drawer = ({ lang, isShow, setIsShow, renderContent, headerText, drawerFooter, renderFooter, renderHeader, }) => {
    const footer = (drawerFooter || renderFooter) && (React.createElement(Footer, null,
        renderFooter && renderFooter(),
        drawerFooter && (React.createElement(React.Fragment, null,
            React.createElement(Button.Default, { height: "LARGE", width: "WIDE", onClick: drawerFooter.onCancelClick }, drawerFooter.cancelText),
            React.createElement(Button.Primary, { height: "LARGE", width: "WIDE", onClick: drawerFooter.onConfirmClick }, drawerFooter.confirmText)))));
    const header = (React.createElement(React.Fragment, null,
        renderHeader && renderHeader(),
        headerText && (React.createElement(Header, null,
            React.createElement(Text, { lang: lang, fontType: "Heading", color: "INK_800" }, headerText)))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Mask, { isShow: isShow, onClick: () => setIsShow(false) }),
        React.createElement(Container, { isShow: isShow },
            header,
            React.createElement(Body, null, renderContent()),
            footer)));
};
export default Drawer;
//# sourceMappingURL=Drawer.js.map